import { useTranslation } from 'react-i18next';
import React, {useEffect, useState, Fragment, } from "react";
import { useParams, } from "react-router-dom";
import apiRequest from '../../functions/api';
import { Typography,Box,TextField,InputAdornment,Grid,ListItemAvatar,ListItem,Button,ButtonGroup, Hidden,} from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import { useMessage } from "../../context/message-context";
import openFile from "../shared/functions/download";
import axios from 'axios';
import {API_BASE_URL} from '../../constants/apiConstants';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import {FullPageSpinner} from '../lib';
function StammformularVertrag(props) {
  const { t } = useTranslation();
  let { stammblattid } = useParams();
  const {client, accessToken,} = props;
  const [isLoading, setIsLoading] = useState(false);
  const {hideMessage, showErrorMessage} = useMessage();
  const [eingaben,setEingaben] = useState([]);
  const [farbevoll,setFarbeVoll] = useState();
  const [farbefehler,setFarbeFehler] = useState ();
  const [farbeoptional,setFarbeOptional] = useState ();
  const [showModal, setShowModal] = useState(false);
  const [land, setLand] = useState(false);
  const [plz,setPLZ] = useState("");
  const [vertraege,setVertraege] = useState([]);
  const [laender,setLaender] = useState([]);
  const [str,setStr] = useState();
  const [orte,setOrte] = useState([]);
  const [ort,setOrt] = useState("");
  const [strassen,setStrassen] = useState([]);
  const [block,setBlock] = useState("");
  const [vertragvoll,setVertragVoll]=useState(false);
  const [adressevoll,setAdresseVoll]=useState(false);
  const [arbeitnehmervoll,setArbeitnehmervoll]=useState(false);
  const [anname,setAnName] = useState("");
  const [vertrag,setVertrag] = useState("");
  
  const user_name = localStorage.getItem(client+"LPB1-USERNAME")?localStorage.getItem(client+"LPB1-USERNAME"):""
  const user_vorname = localStorage.getItem(client+"LPB1-USERVORNAME")?localStorage.getItem(client+"LPB1-USERVORNAME"):""
  const user_titel = localStorage.getItem(client+"LPB1-USERTITEL")?localStorage.getItem(client+"LPB1-USERTITEL"):""
//Laden der daten bei Ã¶ffnen der Seite
  useEffect(() => {
    vertragInit();
      // eslint-disable-next-line
  }, [])
  
  useEffect(() => {
    if (eingaben.length>0) {
      var vertag_wert=true;
      var adress_wert=true;
      var arbeitnehmer_wert=true;
      for (let index = 0; index < eingaben.length; index++) {
        if (eingaben[index].block==="vertrag") {
          if (!eingaben[index].antwort ) {
            if (!eingaben[index].optional) {
              vertag_wert=false
            }
          }
        }
        if (eingaben[index].block==="adresse") {
          if (!eingaben[index].antwort ) {
            if (!eingaben[index].optional) {
              adress_wert=false
            }
          }
        }
        if (eingaben[index].block==="arbeitnehmer") {
          if (!eingaben[index].antwort ) {
            if (!eingaben[index].optional) {
              arbeitnehmer_wert=false
            }
          }
        }
      }
      setVertragVoll(vertag_wert)
      setAdresseVoll(adress_wert)
      setArbeitnehmervoll(arbeitnehmer_wert)
    }
      // eslint-disable-next-line
  }, [eingaben])
  const holePlzDaten = (plz_eingabe) => {
    const payload={
      "mandant": client,
      "program": "LPB1AP",
      "statement": "VERTRAG_PLZ",
      "plz":plz_eingabe,
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, plzCB);      
  }
  
  const plzCB = (response) => {
    if (response.status === 200) {
      if (response.data.orte) {
        setOrte(response.data.orte);
        if (response.data.orte.length===1) {
          var frage=eingaben.find(element=> (element.feld==="LPB1-WOHNORT"));
          var fragennr=eingaben.indexOf(frage);
          schreibe_antwort(fragennr,response.data.orte[0].ort,"");
          setOrt(response.data.orte[0].ort);
        }
      }
      if (response.data.strasse) {
        setStrassen(response.data.strasse);
      }       
      setIsLoading(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  const vertragInit = () => {
    setIsLoading(true);
    const payload={
      "mandant": client,
      "program": "LPB1AP",
      "statement": "VERTRAG_INIT",
      "key":stammblattid,
      "user_name":user_name,
      "user_vorname":user_vorname,
      "user_titel":user_titel,
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, vertragCB);      
  }
  
  const vertragCB = (response) => {
    if (response.status === 200) {
      if (response.data.vertraege) {
        setVertraege(response.data.vertraege);
      }
      if (response.data.land) {
        setLaender(response.data.land);
      }
      if (response.data.eingaben) {
        setEingaben(response.data.eingaben);
      } 
      if (response.data.farbe_voll) {
        setFarbeVoll(response.data.farbe_voll);
      }
      if (response.data.farbe_unvoll) {
        setFarbeFehler(response.data.farbe_unvoll);
      }
      if (response.data.farbe_optional) {
        setFarbeOptional(response.data.farbe_optional);
      }    
      if (response.data.nkz) {
        setLand(response.data.nkz);
      }
  
      if (response.data.plz) {
        setPLZ(response.data.plz);
      }
      if (response.data.str) {
        setStr(response.data.str);
      }
      if (response.data.ort) {
        setOrt(response.data.str);
      }
      if (response.data.orte) {
        setOrte(response.data.orte);
      }
      if (response.data.strasse) {
        setStrassen(response.data.strasse);
      } 
      
      if (response.data.an_name) {
        setAnName(response.data.an_name)
      }
      setIsLoading(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  function schreibe_antwort (punkt_lfd,punkt_antwort,feld) {
    var temp_daten=eingaben.slice();
    temp_daten[punkt_lfd]["antwort"]=punkt_antwort;
    setEingaben(temp_daten);
    
    if (feld==="LPB1-NKZ") {
      setLand(punkt_antwort);
      setOrte([]);
    }
    if (feld==="LPB1-WOHNORT") {
      setOrt(punkt_antwort);
    }
    if (feld==="LPB1-STRASSE") {
      setStr(punkt_antwort);
    }
    if (feld==="VERTRAG") {
      setVertrag(punkt_antwort);
    }
    if (feld==="USER_VORNAME") {
      localStorage.setItem(client+"LPB1-USERVORNAME",punkt_antwort)
    }
    if (feld==="USER_NACHNAME") {
      localStorage.setItem(client+"LPB1-USERNAME",punkt_antwort)
    }
    if (feld==="USER_TITEL") {
      localStorage.setItem(client+"LPB1-USERTITEL",punkt_antwort)
    }
  }
  const setze_eingabe_antwort = (fragenlfd,value,feld) => {
    var temp_daten=eingaben.slice();
    temp_daten[fragenlfd]["antwort"]=value;
    setEingaben(temp_daten); 
    
    if (feld && feld==="LPB1-PLZ") {
      setPLZ(value);
      setOrt("");
      setStr("");
      if (land==="   ") {
      if (value.length>4) {
        setIsLoading(true);
        holePlzDaten(value);
      }
     }
    }
  }
  
  const downloadFile = (key,datname) => {
    console.log('file with key: ', key);
    const payload={
        "mandant": client, 
        "program": "LPB1AP",
        "statement": "VERTRAG_DRUCK",
        "key": key,
        "eingaben":eingaben,
        "eingebeanzahl":eingaben.length,
    }
    const headers={
        "Authorization": "Bearer "+accessToken,
        "Accept": "application/pdf"
    }
    axios.post(API_BASE_URL+'daten', payload, {headers: headers, responseType: 'blob'})
      .then((response) => {
        console.log(response);
        var fileName = datname+".pdf";
        var contentFile = response.data;
        openFile(fileName, contentFile);
        closeModal();
      })
      .catch(function (error) {
        console.log(error);
        closeModal();
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  }
  const closeModal = () => {
    setShowModal(false);
  }
  
  if (isLoading) {
    return <LoadingComponent />
  }
    
  const eingabenZeichnen = eingaben.map((element,count) => {
    var zeichnen=""
    if (element.block!==block) {
      return (
        <Fragment></Fragment> 
      )
    }
    if (element.art==="menubutton") {
      zeichnen=
        <Grid item xs={12}>
        <ListItem  variant="inset" component="li" light>
        <ListItemAvatar>
        { (element.menu==="vertrag" && vertragvoll) || (element.menu==="adresse" && adressevoll) || (element.menu==="arbeitnehmer" &&arbeitnehmervoll) ?
                  <CheckCircleOutlineIcon style={{color:"rgba("+farbevoll+" ,0.8)"}} />
                  :
                  <ErrorOutlineIcon style={{color:"rgba("+farbefehler+" ,0.8)"}}/>
        }  
        </ListItemAvatar>
        <Button fullWidth  variant="outlined"  onClick={()=>setBlock(element.menu)} >
          {element.bez}
        </Button>   
      </ListItem>
      </Grid>
    }
    if (element.art==="eingabe") {
      if (element.feld==="LPB1-PLZ" && !land) {
        zeichnen=
          <Grid item xs={12}>
            <Typography>{t("Bitte wählen Sie ein Land aus")}</Typography>
          </Grid>
      }
      if (element.feld==="LPB1-HAUSNR" && !str && land==="   ") {
        return (
          <Fragment></Fragment>
        )
      }
      zeichnen=
        <Grid item xs={12}>
          <TextField
            label={element.bez}
            variant="outlined"
            fullWidth
            type={element.typ && element.typ}
            value={element.antwort}
            error={ (!element.antwort || element.antwort==="") && (!element.optional) }
            onKeyDown={
              (taste) => 
              taste.key==="Enter" &&
              taste.target.blur()   
            }
            onChange={ (event) => setze_eingabe_antwort(count,event.target.value,element.feld)}
            onBlur={  (event) => schreibe_antwort(count,element.antwort,element.feld)}
            InputProps={{
              startAdornment: (
              <InputAdornment position="start">
                { element.antwort && element.antwort!=="" ?
                  <CheckCircleOutlineIcon style={{color:"rgba("+farbevoll+" ,0.8)"}} />
                  :   
                   element.optional ?
                  <Brightness1Icon style={{color:"rgba("+farbeoptional+" ,0.8)"}}/>
                  :
                  <ErrorOutlineIcon style={{color:"rgba("+farbefehler+" ,0.8)"}}/>
                }            
                    </InputAdornment>
                    ),
                  }}
                InputLabelProps={{
                  shrink: true,
                }}         
            />
        </Grid>
    }
    if (element.art==="auswahl") {
      if (element.auswahl) {
        if (element.auswahl.length>0) {
          zeichnen=
          <Grid item xs={12}>
          <Autocomplete
            noOptionsText={t("kein Eintrag gefunden")}
            onChange={(event, newValue) => {
              newValue!==null ? 
              schreibe_antwort(count,newValue.key,element.feld)
              :
              schreibe_antwort(count,"",element.feld)
            }}
            options={element.auswahl}
            getOptionLabel={(option) => option.bez}
            defaultValue={
              element.antwort ? element.auswahl.find((antwort) => antwort.key===element.antwort) : element.antwort
            } 
            renderInput={(params) => 
              <TextField 
                  {...params} 
                  label={element.bez}
                  variant="outlined"
                  error={element.antwort_vorhanden==="0"}
                  InputLabelProps={{
                      shrink: true,
                  }} 
                  
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                    <InputAdornment position="start">
                    {  element.auswahl.find(antwort=> antwort.key===element.antwort) ?
                       <CheckCircleOutlineIcon style={{color:"rgba("+farbevoll+" ,0.8)"}} />                  
                       :
                       <ErrorOutlineIcon style={{color:"rgba("+farbefehler+" ,0.8)"}}/>
                    }                      
                    </InputAdornment>
                    ),
                    }}                        
              />}
            />
            </Grid>
        } else {
          return (
          <Fragment></Fragment>
          )
        }
      }
      if (element.feld==="VERTRAG") {
        zeichnen=
          <Grid item xs={12}>
          <Autocomplete
            noOptionsText={t("kein Eintrag gefunden")}
            onChange={(event, newValue) => {
              newValue!==null ? 
              schreibe_antwort(count,newValue.key,element.feld)
              :
              schreibe_antwort(count,"",element.feld)
            }}
            options={vertraege}
            getOptionLabel={(option) => option.name}
            defaultValue={
              element.antwort ? vertraege.find((antwort) => antwort.key===element.antwort) : element.antwort
            } 
            renderInput={(params) => 
              <TextField 
                  {...params} 
                  label={element.bez}
                  variant="outlined"
                  error={element.antwort_vorhanden==="0"}
                  InputLabelProps={{
                      shrink: true,
                  }} 
                  
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                    <InputAdornment position="start">
                    {  vertraege.find(antwort=> antwort.key===element.antwort) ?
                       <CheckCircleOutlineIcon style={{color:"rgba("+farbevoll+" ,0.8)"}} />                  
                       :
                       <ErrorOutlineIcon style={{color:"rgba("+farbefehler+" ,0.8)"}}/>
                    }                      
                    </InputAdornment>
                    ),
                    }}                        
              />}
            />
            </Grid>
      }
      if (element.feld==="LPB1-NKZ") {
        zeichnen=
          <Grid item xs={12}>
          <Autocomplete
            noOptionsText={t("kein Eintrag gefunden")}
            onChange={(event, newValue) => {
              newValue!==null ? 
              schreibe_antwort(count,newValue.key,element.feld)
              :
              schreibe_antwort(count,"",element.feld)
            }}
            options={laender}
            getOptionLabel={(option) => option.title}
            getOptionSelected={(option) => element.antwort!=="" ? element.antwort===option.key  : ""}
            defaultValue={
              element.antwort ? laender.find((antwort) => antwort.key===element.antwort) : element.antwort
            }   
            
            renderInput={(params) => 
              <TextField 
                  {...params} 
                  label={element.bez}
                  variant="outlined"
                  InputLabelProps={{
                      shrink: true,
                  }} 
                  
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                    <InputAdornment position="start">
                    {  laender.find(antwort=> antwort.key===element.antwort) ?
                       <CheckCircleOutlineIcon style={{color:"rgba("+farbevoll+" ,0.8)"}} />                  
                       :
                       <ErrorOutlineIcon style={{color:"rgba("+farbefehler+" ,0.8)"}}/>
                    }                      
                    </InputAdornment>
                    ),
                    }}                        
              />}
            />
            </Grid>
      }
      
      if (element.feld==="LPB1-STRASSE") {
        if (land==="   " && (!ort || ort==="") ) {
          return (
            <Fragment></Fragment>
          )
        }
        if (ort!=="" || land!=="   " ) {
          if (land!=="   ") {
            zeichnen=
            <Grid item xs={12}>
            <TextField
              label={element.bez}
              variant="outlined"
              fullWidth
              value={element.antwort}
              error={ !element.antwort || element.antwort===""}
              onKeyDown={
                (taste) => 
                taste.key==="Enter" &&
                taste.target.blur()   
              }
              onChange={ (event) => setze_eingabe_antwort(count,event.target.value,element.feld)}
              onBlur={  (event) => schreibe_antwort(count,element.antwort,element.feld)}
              InputProps={{
                startAdornment: (
                <InputAdornment position="start">
                  { element.antwort && element.antwort!=="" ?
                    <CheckCircleOutlineIcon style={{color:"rgba("+farbevoll+" ,0.8)"}} />
                    :
                    <ErrorOutlineIcon style={{color:"rgba("+farbefehler+" ,0.8)"}}/>
                  }            
                      </InputAdornment>
                      ),
                    }}
                  InputLabelProps={{
                    shrink: true,
                  }}         
              />
            </Grid>          
          } else {
            zeichnen=
              <Grid item xs={12}>
              <Autocomplete
                noOptionsText={t("kein Eintrag gefunden")}
                onChange={(event, newValue) => {
                  newValue!==null ? 
                  schreibe_antwort(count,newValue.strasse,element.feld)
                  :
                  schreibe_antwort(count,"",element.feld)
                }}
                options={strassen}
                getOptionLabel={(option) => option.strasse}
    
                defaultValue={
                  (element.antwort && element.antwort!=="") ? strassen.find(antwort=> antwort.strasse===element.antwort) : element.antwort
                }
    
                renderInput={(params) => 
                  <TextField 
                      {...params} 
                      label={element.bez}
                      variant="outlined"
                      error={element.antwort_vorhanden==="0"}
                      InputLabelProps={{
                          shrink: true,
                      }} 
                      
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                        <InputAdornment position="start">
    
                        {  strassen.find(antwort=> antwort.strasse===element.antwort) ?
                           <CheckCircleOutlineIcon style={{color:"rgba("+farbevoll+" ,0.8)"}} />                  
                           :
                           <ErrorOutlineIcon style={{color:"rgba("+farbefehler+" ,0.8)"}}/>
                        }                      
                        </InputAdornment>
                        ),
                        }}                        
                  />}
                />
                </Grid> 
          }
        } 
      }
      if (element.feld==="LPB1-WOHNORT") {
        if (land==="   " && plz.length<5 ) {
          return(
            <Fragment></Fragment>
          )
        }
        if (orte.length<2 && (plz || land!=="   " )) {
          zeichnen=
            <Grid item xs={12}>
            <TextField
              label={element.bez}
              variant="outlined"
              fullWidth
              disabled={orte.length===1 && land==="   "}
              value={element.antwort}
              error={ !element.antwort || element.antwort===""}
              onKeyDown={
                (taste) => 
                taste.key==="Enter" &&
                taste.target.blur()   
              }
              onChange={ (event) => setze_eingabe_antwort(count,event.target.value,element.feld)}
              onBlur={  (event) => schreibe_antwort(count,element.antwort,element.feld)}
              InputProps={{
                startAdornment: (
                <InputAdornment position="start">
                  { element.antwort && element.antwort!=="" ?
                    <CheckCircleOutlineIcon style={{color:"rgba("+farbevoll+" ,0.8)"}} />
                    :
                    <ErrorOutlineIcon style={{color:"rgba("+farbefehler+" ,0.8)"}}/>
                  }            
                      </InputAdornment>
                      ),
                    }}
  
                  InputLabelProps={{
                    shrink: true,
                  }}
              />
          </Grid>
        }
        if (orte.length>1 && plz) {
          zeichnen=
          <Grid item xs={12}>
          <Autocomplete
            noOptionsText={t("kein Eintrag gefunden")}
            onChange={(event, newValue) => {
              newValue!==null ? 
              schreibe_antwort(count,newValue.ort,element.feld)
              :
              schreibe_antwort(count,"",element.feld)
            }}
            options={orte}
            getOptionLabel={(option) => option.ort}
            defaultValue={
              element.antwort ? orte.find(antwort=> antwort.ort===element.antwort)  : element.antwort
            }
            renderInput={(params) => 
              <TextField 
                  {...params} 
                  label={element.bez}
                  variant="outlined"
                  error={element.antwort_vorhanden==="0"}
                  InputLabelProps={{
                      shrink: true,
                  }} 
                  
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                    <InputAdornment position="start">
                    {  orte.find(antwort=> antwort.ort===element.antwort) ?
                       <CheckCircleOutlineIcon style={{color:"rgba("+farbevoll+" ,0.8)"}} />                  
                       :
                       <ErrorOutlineIcon style={{color:"rgba("+farbefehler+" ,0.8)"}}/>
                    }                      
                    </InputAdornment>
                    ),
                    }}                        
              />}
            />
            </Grid> 
      }
      }
    }
    return(zeichnen)
  }   
  )
  return (
    <Page >
    <Layout>
      <Box pl={2} pr={2} pt={1} pb={1}>
          <Typography variant="h6">{t("Arbeitsvertrag drucken")}</Typography>
      </Box>
      <Grid item xs={12}>          
        <Hidden smUp>
          <ButtonGroup variant="text" orientation="vertical" disabled fullWidth>
            <Button size="small" startIcon={<CheckCircleOutlineIcon  style={{color:"rgba("+farbevoll+" ,0.8)"}} />}   >
              {<Typography style={{color:"rgba("+farbevoll+" ,0.8)"}}>{t("= vollständig")}</Typography>}
            </Button> 
            <Button startIcon={<ErrorOutlineIcon   style={{color:"rgba("+farbefehler+" ,0.8)"}}/>}  >
              {<Typography style={{color:"rgba("+farbefehler+" ,0.8)"}}>{t("= unvollständig")}</Typography>}
            </Button> 
            <Button startIcon={<Brightness1Icon  style={{color:"rgba("+farbeoptional+" ,0.8)"}}  />} >
              {<Typography style={{color:"rgba("+farbeoptional+" ,0.8)"}}>{t("= optional")}</Typography>}           
            </Button> 
          </ButtonGroup>
        </Hidden>
                  
        <Hidden mdDown>
          <ButtonGroup variant="text" disabled fullWidth>
            <Button size="small" startIcon={<CheckCircleOutlineIcon  style={{color:"rgba("+farbevoll+" ,0.8)"}} />}   >
              {<Typography style={{color:"rgba("+farbevoll+" ,0.8)"}}>{t("= vollständig")}</Typography>}
            </Button> 
            <Button startIcon={<ErrorOutlineIcon   style={{color:"rgba("+farbefehler+" ,0.8)"}}/>}  >
              {<Typography style={{color:"rgba("+farbefehler+" ,0.8)"}}>{t("= unvollständig")}</Typography>}
            </Button> 
            <Button startIcon={<Brightness1Icon  style={{color:"rgba("+farbeoptional+" ,0.8)"}}  />} >
              {<Typography style={{color:"rgba("+farbeoptional+" ,0.8)"}}>{t("= optional")}</Typography>}           
            </Button> 
          </ButtonGroup>     
        </Hidden>
      </Grid>
      <Grid container justifyContent="flex-start" spacing={2} alignItems="center" >   
        {eingabenZeichnen}
        { block !=="" &&
           <Grid item xs={12}>
           <Button fullWidth  variant="contained" color="primary"  onClick={()=>setBlock("")} >
             {t("Zurück")}
           </Button>   
         </Grid>                
        }
        {  (block==="") && (arbeitnehmervoll && vertragvoll && adressevoll && vertrag!=="" ) &&
           <Grid item xs={12}>
            <Button fullWidth  variant="contained" color="primary"  onClick={()=>{downloadFile(stammblattid, vertraege.find(antwort=> antwort.key===vertrag).name + " " +anname )}} >
               {t("Vertrag Drucken")}
             </Button>   
          </Grid>              
        }
      </Grid>
        {showModal && <FullPageSpinner/>} 
      </Layout>
    </Page>
  );
}
export default StammformularVertrag; 
